import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { createUltimatePagination } from 'react-ultimate-pagination';
import { i18n } from '../i18n/translate.js';
import { FAIcon } from './fa-icon/component.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';

var PaginationComponentButton = function PaginationComponentButton(props) {
  var className = _formatClassName({
    active: props.isActive,
    disabled: props.isDisabled,
    'arrow-button': props.isArrowButton
  });

  return /*#__PURE__*/React.createElement("li", {
    className: className,
    disabled: props.isDisabled
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": props.label,
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement("span", null, props.value)));
};

PaginationComponentButton.displayName = "PaginationComponentButton";
PaginationComponentButton.propTypes = {
  isActive: PropTypes.bool,
  isArrowButton: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.node
};

var PaginationComponentPage = function PaginationComponentPage(props) {
  return PaginationComponentButton(props);
};

var PaginationComponentEllipsis = function PaginationComponentEllipsis(props) {
  return PaginationComponentButton(_objectSpread2(_objectSpread2({}, props), {}, {
    isDisabled: true,
    onClick: null,
    value: '…',
    label: i18n.t('More')
  }));
};

var PaginationComponentFirstPageLink = function PaginationComponentFirstPageLink(props) {
  return PaginationComponentButton(_objectSpread2(_objectSpread2({}, props), {}, {
    isDisabled: props.isActive,
    isArrowButton: true,
    value: '«',
    label: i18n.t('First')
  }));
};

var PaginationComponentPreviousPageLink = function PaginationComponentPreviousPageLink(props) {
  return PaginationComponentButton(_objectSpread2(_objectSpread2({}, props), {}, {
    isDisabled: props.isActive,
    isArrowButton: true,
    value: /*#__PURE__*/React.createElement(FAIcon, {
      icon: "arrow-left"
    }),
    label: i18n.t('Previous')
  }));
};

var PaginationComponentNextPageLink = function PaginationComponentNextPageLink(props) {
  return PaginationComponentButton(_objectSpread2(_objectSpread2({}, props), {}, {
    isDisabled: props.isActive,
    isArrowButton: true,
    value: /*#__PURE__*/React.createElement(FAIcon, {
      icon: "arrow-right"
    }),
    label: i18n.t('Next')
  }));
};

var PaginationComponentLastPageLink = function PaginationComponentLastPageLink(props) {
  return PaginationComponentButton(_objectSpread2(_objectSpread2({}, props), {}, {
    isDisabled: props.isActive,
    isArrowButton: true,
    value: '»',
    label: i18n.t('Last')
  }));
};

var PaginationComponentWrapper = function PaginationComponentWrapper(props) {
  var className = _formatClassName(['pagination', {
    'pagination-branded': props.isBranded
  }]);

  return /*#__PURE__*/React.createElement("div", {
    className: "pagination-wrapper ui-default"
  }, /*#__PURE__*/React.createElement("ul", {
    className: className
  }, props.children));
};

PaginationComponentWrapper.displayName = "PaginationComponentWrapper";
PaginationComponentWrapper.propTypes = {
  children: PropTypes.node,
  isBranded: PropTypes.bool
};
var itemTypeToComponent = {
  PAGE: PaginationComponentPage,
  ELLIPSIS: PaginationComponentEllipsis,
  FIRST_PAGE_LINK: PaginationComponentFirstPageLink,
  PREVIOUS_PAGE_LINK: PaginationComponentPreviousPageLink,
  NEXT_PAGE_LINK: PaginationComponentNextPageLink,
  LAST_PAGE_LINK: PaginationComponentLastPageLink
};
var UltimatePagination = createUltimatePagination({
  itemTypeToComponent: itemTypeToComponent,
  WrapperComponent: PaginationComponentWrapper
});
var PaginationComponent = UltimatePagination;
export { PaginationComponent };